(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 53150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z5": function() { return /* reexport */ Routes; }
});

// UNUSED EXPORTS: LoadableRoute, render, renderRoute, renderRoutes

// EXTERNAL MODULE: ./shared/components/react-router/node_modules/@loadable/component/dist/loadable.esm.js
var loadable_esm = __webpack_require__(9512);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./shared/components/react-router/LoadableRoute/index.tsx


const _excluded = (/* unused pure expression or super */ null && (["fallback", "component"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function LoadableRoute(_ref) {
  let fallback = _ref.fallback,
      component = _ref.component,
      routeProps = _objectWithoutProperties(_ref, _excluded);

  const LoadableComponent = loadable(component, {
    fallback
  });
  return /*#__PURE__*/_jsx(Route, _objectSpread(_objectSpread({}, routeProps), {}, {
    render: () => /*#__PURE__*/_jsx(LoadableComponent, {})
  }));
}
/* harmony default export */ var react_router_LoadableRoute = ((/* unused pure expression or super */ null && (LoadableRoute)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
;// CONCATENATED MODULE: ./shared/components/react-router/Routes/helper.tsx


function helper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function helper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? helper_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : helper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/**
 * render
 */
function _render(route, componentProps, extraProps) {
  return route.render ? route.render(componentProps, extraProps !== null && extraProps !== void 0 ? extraProps : {}) : route.component ? /*#__PURE__*/(0,jsx_runtime.jsx)(route.component, helper_objectSpread(helper_objectSpread({
    route: route
  }, componentProps), extraProps)) : null;
}



/**
 * 渲染单个 Route
 */
function renderRoute(route, {
  extraProps,
  matchPath
}) {
  // path 优先于 extraProps
  let path;

  if (route.path !== undefined) {
    path = route.path;
  } else if (route.relativePath !== undefined) {
    path = matchPath ? `${matchPath}${route.relativePath}` : route.relativePath;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
    path: path,
    exact: route.exact,
    strict: route.strict,
    render: componentProps => _render(route, componentProps, extraProps)
  }, route.key);
}
/**
 * 渲染多个 Route
 */

function renderRoutes(routes, {
  matchPath,
  extraProps,
  routeRender
} = {}) {
  return routes.map((route, i) => {
    var _route$key;

    return renderRoute(helper_objectSpread(helper_objectSpread({}, route), {}, {
      key: (_route$key = route.key) !== null && _route$key !== void 0 ? _route$key : i,
      render: routeRender ? (componentProps, extraProps) => routeRender({
        route,
        props: componentProps,
        extraProps,
        render: _render
      }) : route.render
    }), {
      extraProps,
      matchPath
    });
  });
}
;// CONCATENATED MODULE: ./shared/components/react-router/Routes/Routes.tsx


function Routes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Routes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Routes_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Routes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/**
 * Routes
 */



function Routes({
  routes,
  extraProps,
  default: defaultComponent,
  notFond,
  switchProps,
  routeRender
}) {
  const _useRouteMatch = (0,react_router/* useRouteMatch */.$B)(),
        matchPath = _useRouteMatch.path;

  if (!routes) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, Routes_objectSpread(Routes_objectSpread({}, switchProps), {}, {
    children: [renderRoutes(routes, {
      routeRender,
      extraProps,
      matchPath
    }), defaultComponent && /*#__PURE__*/(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
      path: matchPath,
      exact: true,
      children: defaultComponent
    }), notFond && /*#__PURE__*/(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
      path: "*",
      children: notFond
    })]
  }));
}
/* harmony default export */ var Routes_Routes = ((/* unused pure expression or super */ null && (Routes)));
;// CONCATENATED MODULE: ./shared/components/react-router/Routes/index.tsx




;// CONCATENATED MODULE: ./shared/components/react-router/index.ts



/***/ }),

/***/ 66346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qi": function() { return /* binding */ SyncRouterStore; },
/* harmony export */   "sH": function() { return /* binding */ RouterStore; }
/* harmony export */ });
/* unused harmony export useSync */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var _my_mobx_rootstore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10566);
/* harmony import */ var _my_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81305);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68949);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16550);






/**
 * useSync
 */

function useSync() {
  const routerStore = (0,_my_mobx_rootstore__WEBPACK_IMPORTED_MODULE_0__/* .useStore */ .oR)(RouterStore);
  const history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useHistory */ .k6)();
  const historyRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  if (!historyRef.current || historyRef.current !== history) {
    historyRef.current = history;
    routerStore.setHistory(history);
  }

  const location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)();
  const locationRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  if (!locationRef.current || locationRef.current !== location) {
    locationRef.current = location;
    routerStore.setLocation(location);
  }

  const searchRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  if (searchRef.current !== location.search) {
    routerStore.setQuery((0,_my_router__WEBPACK_IMPORTED_MODULE_1__/* .toQueryObject */ .J2)(location.search));
  }

  return routerStore;
}
/**
 * SyncRouterStore
 */

function SyncRouterStore() {
  useSync();
  return null;
}
/**
 * RouterStore
 */

class RouterStore {
  /**
   * query
   */
  constructor() {
    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "query", {});

    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "_history", void 0);

    (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "_location", void 0);

    (0,mobx__WEBPACK_IMPORTED_MODULE_5__/* .makeAutoObservable */ .ky)(this);
  }

  get history() {
    if (false) {}

    return this._history;
  }

  get location() {
    if (false) {}

    return this._location;
  }

  setHistory(history) {
    this._history = history;
  }

  setLocation(location) {
    this._location = location;
  }

  setQuery(query) {
    this.query = query;
  }

  replace(params) {
    return (0,_my_router__WEBPACK_IMPORTED_MODULE_1__/* .replace */ .gx)(this.history, params);
  }

  push(params) {
    return (0,_my_router__WEBPACK_IMPORTED_MODULE_1__/* .push */ .VF)(this.history, params);
  }

}
/* harmony default export */ __webpack_exports__["ZP"] = (RouterStore);

/***/ }),

/***/ 81305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J2": function() { return /* binding */ toQueryObject; },
/* harmony export */   "VF": function() { return /* binding */ push; },
/* harmony export */   "aM": function() { return /* binding */ useQuery; },
/* harmony export */   "gx": function() { return /* binding */ replace; }
/* harmony export */ });
/* unused harmony exports useSetQuery, toQueryString, toLocation, resolveToLocation, normalizeToLocation */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16550);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);


const _excluded = ["query", "search"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useQuery() {
  const location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
  const setQuery = useSetQuery();
  const queryObj = toQueryObject(location.search);
  return [queryObj, setQuery];
}
function useSetQuery() {
  const history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)();
  return function setQuery(query) {
    const search = toQueryString(query);
    history.replace(_objectSpread(_objectSpread({}, location), {}, {
      search
    }));
  };
}
/**
 * replace
 *
 * 与 history.replace 基本一样，多了 query 参数
 */

function replace(history, params) {
  return history.replace(typeof params === 'string' ? params : toLocation(params));
}
/**
 * push
 *
 * 与 history.push 基本一样，多了 query 参数
 */

function push(history, params) {
  return history.push(typeof params === 'string' ? params : toLocation(params));
}
function toQueryString(queryObject) {
  return query_string__WEBPACK_IMPORTED_MODULE_1__.stringify(queryObject, {
    arrayFormat: 'bracket'
  });
}
function toQueryObject(query) {
  return query ? query_string__WEBPACK_IMPORTED_MODULE_1__.parse(query, {
    parseBooleans: true,
    parseNumbers: true,
    arrayFormat: 'bracket'
  }) : {};
}
function toLocation(_ref) {
  let query = _ref.query,
      search = _ref.search,
      restParams = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const searchStr = query ? toQueryString(query) : search;
  return _objectSpread(_objectSpread({}, restParams), {}, {
    search: searchStr
  });
}
const resolveToLocation = (to, currentLocation) => typeof to === 'function' ? to(currentLocation) : to;
const normalizeToLocation = (to, currentLocation) => {
  return typeof to === 'string' ? createLocation(to, undefined, undefined, currentLocation) : to;
};

/***/ }),

/***/ 12691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(71217);
// EXTERNAL MODULE: ./shared/packages/mobx-rootstore/index.tsx + 1 modules
var mobx_rootstore = __webpack_require__(10566);
// EXTERNAL MODULE: ./src/stores/modules/auth/AuthStore.ts
var AuthStore = __webpack_require__(58770);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(73727);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Router.tsx



function Router({
  children
}) {
  const router = (0,next_router.useRouter)();
  let component;

  if (false) {} else {
    component = /*#__PURE__*/(0,jsx_runtime.jsx)(react_router_dom/* BrowserRouter */.VK, {
      basename: router.basePath,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    suppressHydrationWarning: true,
    children: component
  });
}
/* harmony default export */ var components_Router = ((/* unused pure expression or super */ null && (Router)));
// EXTERNAL MODULE: ./shared/components/react-router/index.ts + 4 modules
var components_react_router = __webpack_require__(53150);
// EXTERNAL MODULE: ./shared/packages/mobx-rootstore-router/index.ts
var mobx_rootstore_router = __webpack_require__(66346);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/pages/routes.ts

const routes = [{
  path: '/workspace',
  component: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(4696), __webpack_require__.e(4300), __webpack_require__.e(3966), __webpack_require__.e(1975)]).then(__webpack_require__.bind(__webpack_require__, 81975)), {
    ssr: false,
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(81975)]
    }
  })
}];
;// CONCATENATED MODULE: ./src/pages/index.page.tsx




 // router









const IndexPage = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Router, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(mobx_rootstore_router/* SyncRouterStore */.qi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_react_router/* Routes */.Z5, {
      routes: routes,
      default: /*#__PURE__*/(0,jsx_runtime.jsx)(HomeRedirect, {}),
      notFond: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "404"
      })
    })]
  });
};

const HomeRedirect = (0,es/* observer */.Pi)(() => {
  const authStore = (0,mobx_rootstore/* useStore */.oR)(AuthStore/* AuthStore */.C);
  const router = (0,next_router.useRouter)();
  (0,react.useEffect)(() => {
    if (!authStore.loginSession) {
      router.replace('/login');
      return;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return authStore.loginSession ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: "/workspace"
  }) : null;
});
/* harmony default export */ var index_page = (IndexPage);

/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12691);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9676,9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);